import { type ReactNode, type Ref } from 'react'

import cn from '@components/utils/cn'
import { type useFormField } from '@hooks/useFormField'

type FieldShellProps = {
  field: ReturnType<typeof useFormField>
  label: ReactNode
  labelId?: string
  hideLabel?: boolean
  group?: boolean
  description?: ReactNode
  className?: string
  ref?: Ref<HTMLDivElement>
  children: ReactNode
}

export function FieldShell({
  field,
  label,
  labelId,
  hideLabel,
  group,
  description,
  className,
  ref,
  children,
}: FieldShellProps) {
  const Name = group ? 'span' : 'label'
  return (
    <div ref={ref} className={cn('tw:flex tw:min-w-0 tw:flex-col', className)}>
      <Name
        id={labelId}
        className={cn(
          'tw:mb-0 tw:pb-1 tw:text-sm tw:font-medium tw:text-gray-700',
          group && 'tw:pb-2',
          hideLabel && 'tw:sr-only',
          field.fieldError && 'tw:text-red-600'
        )}
      >
        {label} {field.requiredText}
      </Name>
      {children}
      {description && (
        <p id={field.descriptionId} className="tw:m-0 tw:pt-1 tw:text-sm tw:text-gray-600">
          {description}
        </p>
      )}
      <div role="status" aria-relevant="all">
        {field.fieldError && (
          <p id={field.errorId} className="tw:m-0 tw:pt-1 tw:text-sm tw:font-light tw:text-red-600">
            {field.fieldError.message}
          </p>
        )}
      </div>
    </div>
  )
}
